import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCard/ProgramActivityCard.module.scss';
import {
    IActiveTab,
    TabsSection,
} from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/TabsSection/TabsSection';
import { tabsArrDataMobile } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCard/ProgramActivityCard.utils';
import { TrackedUntrackedAction } from 'components/common/TrackedUntrackedAction/trackedUntrackedAction';
import { ProgramActivityCardStatusSelect } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCard/ProgramActivityCardStatusSelect/ProgramActivityCardStatusSelect';
import { CardContent } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCard/CardContent/CardContent';
import { CustomizedButton } from 'components/common';
import { QueryResponse as CardResponse } from 'api/queries/getMainCard.query';
import React from 'react';
import { Control, UseFormGetValues, UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCard/ProgramActivityCard.types';
import { QueryResponse as boardInitResponse } from 'api/queries/getBoardInitLite.query';
import { FieldErrors } from 'react-hook-form/dist/types/errors';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';
import Icon from 'components/common/Icons/icon';
import { CardHeaderMobile } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCard/CardHeader/CardHeader.mobile';
import { AssigneeAvatarWithSelection } from 'components/common/AssigneeAvatarWithSelection/AssigneeAvatarWithSelection';
import { IAssigneeWithExtraData } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/CreateCard/CreateCard.types';
import { useAssigneeOptionsList } from 'hooks/useAssigneeOptionsList';
import { cardsDataQueryKey } from 'api/queries/getListFilteredCards.query';

interface Props {
    data: CardResponse;
    activeTab: IActiveTab;
    setValue: UseFormSetValue<IFields>;
    control: Control<IFields, any, IFields>;
    setActiveTab: React.Dispatch<React.SetStateAction<IActiveTab>>;
    watch: UseFormWatch<IFields>;
    boardInit: boardInitResponse | undefined;
    errors: FieldErrors<IFields>;
    handleCardClose: () => void;
    register: UseFormRegister<IFields>;
    queryKeys: string[];
    isCardDirty: boolean;
    assignee: IAssigneeWithExtraData | null;
    getValues: UseFormGetValues<IFields>;
}

export const ProgramActivityCardMobile = ({
    data,
    activeTab,
    setValue,
    control,
    setActiveTab,
    watch,
    boardInit,
    errors,
    handleCardClose,
    register,
    queryKeys,
    isCardDirty,
    assignee,
    getValues,
}: Props) => {
    const assigneeOptionsList = useAssigneeOptionsList();

    const handleAssigneeSelection = (value: string) => {
        const { activityId, versionId } = getValues();
        const selectedAssignee = assigneeOptionsList.find((user) => user.assignee.userName === value);
        if (versionId && activityId && selectedAssignee && selectedAssignee.assignee) {
            setValue('assignee', selectedAssignee, { shouldDirty: true });
        }
    };

    return (
        <>
            <div className={classes.mobileActionButtons}>
                <div className={classes.topLeftSide}>
                    <ShareInsightButton title={`activity "${data.title}"`} link={window.location.href} size={'5rem'} />
                    <CustomizedButton
                        type={'submit'}
                        size={'largest'}
                        color={'primary'}
                        id={'cardModalSaveButton'}
                        disabled={!isCardDirty}
                        data-track-id={`button-save-card`}
                        style={{ height: '35px', fontSize: '2.3rem', fontWeight: '400' }}
                    >
                        Save
                    </CustomizedButton>
                </div>
                <div onClick={handleCardClose} id={'closeModalIcon'} className={classes.closeModalButton}>
                    <Icon name={'filter-x-icon'} size={'5rem'} />
                </div>
            </div>
            <CardHeaderMobile control={control} />
            <div className={classes.tabsWithStatusWrapper}>
                <div className={classes.starWrapper}>
                    <ProgramActivityCardStatusSelect
                        control={control}
                        category={watch('category')}
                        originalStatus={watch('originalStatus')}
                        isStatusOrDatesChanged={data.isStatusOrDatesChanged}
                    />
                    <TrackedUntrackedAction
                        isTracked={data.isTracked}
                        taskVersionHashCode={data.taskVersionHashCode}
                        invalidateQueriesKey={['getCard', cardsDataQueryKey]}
                        dataTrackId={'card'}
                    />
                    <div>
                        <AssigneeAvatarWithSelection
                            classname={classes.assigneeAvatar}
                            assignee={assignee?.assignee ?? null}
                            handleSelection={handleAssigneeSelection}
                        />
                    </div>
                </div>
                <TabsSection tabs={tabsArrDataMobile} activeTab={activeTab} setActiveTab={setActiveTab} />
            </div>

            <CardContent
                activeTab={activeTab}
                boardInit={boardInit}
                setValue={setValue}
                watch={watch}
                control={control}
                errors={errors}
                data={data}
                queryKeys={queryKeys}
                register={register}
            />
        </>
    );
};
